import { Cylinder } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CylinderIcon = createLucideIcon(Cylinder);
